<template>
	<v-dialog
		persistent
		v-model="dialog"
		:width="$vuetify.breakpoint.smAndDown ? '100%' : '800px'"
	>
		<v-card
			:class="[$vuetify.breakpoint.smAndDown ? 'pa-1' : 'pa-4', 'pt-0']"
			:loading="sending || loading"
			:disabled="sending || loading"
		>
			<v-card-title class="pb-0">
				<slot name="title"></slot>
			</v-card-title>

			<v-card-subtitle class="mt-0">
				<slot name="subtitle"></slot>
			</v-card-subtitle>

			<v-card-text :class="['pt-0 pb-0', {'pl-3 pr-3': $vuetify.breakpoint.smAndDown}]">
				<slot name="text"></slot>
			</v-card-text>

			<v-card-actions>
				<v-row>
					<v-col cols="12" md="6" class="d-flex justify-start pb-0">
						<slot name="actions-before"></slot>
					</v-col>

					<v-col cols="12" md="6" :class="[
						'd-flex',
						
						$vuetify.breakpoint.mdAndUp
							? 'justify-end'
							: 'flex-column-reverse',
					]">

					<slot name="actions">
						<template v-if="!hidedefaultactions">
							<v-btn
								text
								v-if="btncancel"
								color="primary"
								@click="$emit('cancel')"
								:large="$vuetify.breakpoint.smAndDown"
								:block="$vuetify.breakpoint.smAndDown"
							>
								{{ btnSecondaryText }}
							</v-btn>

							<v-btn
								color="primary"
								v-if="!btnSubmitHiden"
								:loading="sending || loading"
								@click="$emit('send')"
								:disabled="btnsenddisabled"
								:large="$vuetify.breakpoint.smAndDown"
								:block="$vuetify.breakpoint.smAndDown"
								:class="[{ 'mb-3': $vuetify.breakpoint.smAndDown, 'ml-2': $vuetify.breakpoint.mdAndUp }]"
							>
								{{ btnPrimaryText }}
							</v-btn>
						</template>
					</slot>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		value: {
			type: Boolean,
		},

		sending: {
			type: Boolean,
			required: false,
		},

		loading: {
			type: Boolean,
			required: false,
		},		

		btnsenddisabled: {
			type: Boolean,
			required: false,
		},

		btncancel: {
			type: Boolean,
			required: false,
			default: true,
		},		

		hidedefaultactions: {
			type: Boolean,
			required: false,
		},

		btnPrimaryText: {
			type: String,
			required: false,
			default: "Enviar",
		},

		btnSecondaryText: {
			type: String,
			required: false,
			default: "Cancelar",
		},		

		btnSubmitHiden: {
			type: Boolean,
			required: false,
			default: false,
		}		
	},

	data() {
		return {};
	},

	computed: {
		dialog: {
			get() {
				return this.value;
			},

			set(newValue) {
				this.$emit("input", newValue);
			},
		},
	},
};
</script>

<style lang="css" scoped></style>
